var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimationLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M237.642 121.805L225.023 108.216L213.376 119.864L238.613 146.072L239.583 134.424L224.053 118.893",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M228.906 172.279L235.701 165.485L207.552 137.336L194.933 149.954M235.701 153.837L207.552 125.688L201.728 131.512L195.904 125.688L224.053 97.5387L230.847 103.363",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M205.61 71.331L190.08 85.8908L161.931 57.7418L171.637 48.0352",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M193.962 58.7124L190.08 62.5951L183.285 55.8005",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M193.962 58.7124L190.08 62.5951L183.285 55.8005",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M159.989 236.343L156.107 233.431L152.224 237.313",
    stroke: "#0CC6F2",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M171.637 235.372L168.725 232.46L165.813 235.372",
    stroke: "#0CC6F2",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M200.757 64.5364L190.08 74.243L173.579 57.7418L179.403 51.9178",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M140.576 45.1233L105.633 80.0669L99.8087 74.243L93.9847 80.0669L79.4249 65.5071",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "animate size0",
    d: "M103.691 70.3603L131.84 42.2113L119.222 44.1526L93.9848 68.419L88.1608 62.5951L99.8087 51.9178",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "animate size1",
    d: "M172.608 206.252L218.229 159.661L224.053 165.485L178.432 211.106L171.637 204.311",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "animate size1",
    d: "M52.2465 178.103L65.8357 165.485L41.5693 141.218V152.866L54.1878 165.485L49.3345 170.338M62.9237 82.9789L93.9848 114.04L99.8087 108.216L111.457 119.864L105.633 125.688L99.8087 119.864L93.9848 125.688L60.0118 90.7441L52.2465 98.5094",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "animate size2",
    d: "M211.434 76.1843L190.08 97.5387L151.254 57.7418L104.662 103.363L98.8381 97.5387L93.9848 102.392L67.777 77.1549",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "animate size2",
    d: "M216.288 82.9789L190.08 108.216L150.283 68.419L111.457 108.216L127.958 124.717L152.224 101.421",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "animate size2",
    d: "M73.6009 71.331L93.9847 90.7442L98.838 85.8909L104.662 91.7148L151.253 46.0939L157.077 51.9179L163.872 45.1233",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "animate size2",
    d: "M162.901 138.306L150.283 125.688L156.107 119.864L173.579 136.365L161.931 148.013L151.254 137.336L145.43 143.16L185.227 182.957L160.96 206.252",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "animate size3",
    d: "M221.141 89.7735L190.08 119.864L150.283 80.0669L122.134 108.216L127.958 114.04L151.254 91.7148L195.904 137.336L184.256 148.984L195.904 159.661L207.552 148.013L213.376 153.837L200.757 166.455",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "animate size3",
    d: "M225.994 175.191L179.403 221.783L167.755 211.106L161.931 216.93L156.107 211.106L139.606 227.607L133.782 222.754L122.134 233.431L93.9848 205.282L88.1608 211.106L65.8357 187.81L71.6596 181.986L89.1315 200.428",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "animate size3",
    d: "M166.784 152.866L190.08 177.133L195.904 171.309L173.579 148.984L185.227 137.336L157.078 109.187L122.134 142.189L161.931 181.986L139.606 205.282L98.8381 164.514",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "animate size4",
    d: "M146.4 130.541L133.782 143.16L173.579 181.986L139.606 216.93L88.1608 165.485L99.8087 153.837L139.606 194.604L151.254 181.986L111.457 143.16L123.104 131.512L117.281 125.688L105.633 137.336L99.8087 131.512L93.9847 137.336L60.0117 103.363L43.5106 119.864L48.3638 125.688L60.0117 114.04L93.9847 148.984L99.8087 143.16L138.635 181.986",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "animate size4",
    d: "M43.5106 132.482L70.689 159.661L76.5129 153.837L54.1878 131.512L60.0117 125.688L89.1315 153.837L77.4836 165.485L127.958 215.959L122.134 221.783L70.689 171.309L54.1878 187.81L87.1901 222.754L93.9847 216.93L110.486 232.46M227.935 185.869L206.581 207.223L183.285 228.577M176.491 230.519L167.755 222.754L161.931 228.577L156.107 222.754L140.576 238.284L133.782 232.46L127.958 238.284",
    stroke: "#0CBFF2",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.664,
    y: 38.3286,
    width: 5.82394,
    height: 203.838,
    fill: "#F7F8FB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140.576,
    cy: 140.248,
    r: 101,
    stroke: "#F7F8FB",
    strokeWidth: 6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimationLogo);
export default __webpack_public_path__ + "static/media/animation_logo.49f3709d.svg";
export { ForwardRef as ReactComponent };